<template>
    <v-card outlined v-bind="{ loading }" style="overflow: hidden">
        <view-section-title v-if="!hideTitle" v-bind="{ title, actionCols }">
            <template #actions>
                <slot name="actions" />
            </template>
        </view-section-title>
        <v-divider v-if="!hideTitle && !hideDivider" />
        <slot />
    </v-card>
</template>

<script>
import ViewSectionTitle from "./view-section-title.vue";

export default {
    components: {
        ViewSectionTitle,
    },
    props: {
        title: { type: String },
        actionCols: { type: [String, Number], default: "auto" },

        loading: { type: Boolean, default: false },
        hideTitle: { type: Boolean, default: false },
        hideDivider: { type: Boolean, default: false },
    },
};
</script>

<style></style>
